const VAT_RATE = 0.15;

/**
 * Extracts the VAT already included in a VAT-inclusive amount.
 * Because prices (products + the fixed app fee) are shown inclusive of VAT,
 * the included VAT is: amount * rate / (1 + rate).
 * The returned value is informational only and must never be added to the total.
 */
export const calcIncludedVat = (vatInclusiveAmount: number): number =>
  Math.round(((vatInclusiveAmount * VAT_RATE) / (1 + VAT_RATE)) * 100) / 100;